import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";
import { Box, Paper, Typography, Select, MenuItem, Divider } from "@mui/material";
import { Nav } from "react-bootstrap";
import { getReportChartPartner } from "../../redux/handlers/report/getReportChartPartner.handler";
import { ReportPartnerDay } from "pages/report/reportPartnerDay";
export function ReportPartner() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var currentYear = new Date().getFullYear();
    var years = Array.from({
        length: 5
    }, function(_, i) {
        return currentYear - i;
    }); // 5 ปีย้อนหลัง
    var _useState = _sliced_to_array(useState(currentYear), 2), year = _useState[0], setYear = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), dataChart = _useState1[0], setDataChart = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), tabStatus = _useState2[0], setTabStatus = _useState2[1];
    var getReportChartPartnerReducer = useAppSelector(function(state) {
        return state.getReportChartPartnerReducer;
    });
    // Load data
    useEffect(function() {
        dispatch(getReportChartPartner({
            year: String(year)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        year
    ]);
    useEffect(function() {
        setIsLoading(getReportChartPartnerReducer.isFetching);
        if (getReportChartPartnerReducer.data) {
            var _getReportChartPartnerReducer_data;
            setDataChart(getReportChartPartnerReducer === null || getReportChartPartnerReducer === void 0 ? void 0 : (_getReportChartPartnerReducer_data = getReportChartPartnerReducer.data) === null || _getReportChartPartnerReducer_data === void 0 ? void 0 : _getReportChartPartnerReducer_data.data);
        }
    }, [
        getReportChartPartnerReducer
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        sx: {
            p: 3
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานกราฟสะสม Partner"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานกราฟสะสม Partner"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Nav, {
                variant: "pills",
                defaultActiveKey: tabStatus,
                onSelect: function(selectedKey) {
                    return setTabStatus(selectedKey);
                },
                className: "mb-3",
                children: [
                    /*#__PURE__*/ _jsx(Nav.Item, {
                        children: /*#__PURE__*/ _jsx(Nav.Link, {
                            className: "tc-13 nav-danger",
                            eventKey: "1",
                            children: "รายเดือน"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Nav.Item, {
                        children: /*#__PURE__*/ _jsx(Nav.Link, {
                            className: "tc-13 nav-danger",
                            eventKey: "2",
                            children: "รายวัน"
                        })
                    })
                ]
            }),
            tabStatus == 1 && /*#__PURE__*/ _jsx("div", {
                className: "card card-st-3 mb-3",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-xl-3",
                    children: [
                        /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                display: "flex",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(Typography, {
                                    fontSize: 16,
                                    fontWeight: "bold",
                                    sx: {
                                        textAlign: "center",
                                        width: "100%"
                                    },
                                    children: [
                                        "รายงานกราฟสะสม Partner รายเดือน",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("span", {
                                            style: {
                                                fontSize: 14,
                                                fontWeight: 400
                                            },
                                            children: year
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Select, {
                                    value: year,
                                    onChange: function(e) {
                                        return setYear(e.target.value);
                                    },
                                    size: "small",
                                    sx: {
                                        height: 38
                                    },
                                    children: years.map(function(y) {
                                        return /*#__PURE__*/ _jsx(MenuItem, {
                                            value: y,
                                            children: y
                                        }, y);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            sx: {
                                my: 2
                            }
                        }),
                        /*#__PURE__*/ _jsx(ResponsiveContainer, {
                            width: "100%",
                            height: 350,
                            children: /*#__PURE__*/ _jsxs(LineChart, {
                                data: dataChart,
                                children: [
                                    /*#__PURE__*/ _jsx(CartesianGrid, {
                                        strokeDasharray: "3 3",
                                        stroke: "#ccc"
                                    }),
                                    /*#__PURE__*/ _jsx(XAxis, {
                                        dataKey: "month",
                                        tick: {
                                            fontSize: 12
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(YAxis, {
                                        tick: {
                                            fontSize: 12
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Tooltip, {}),
                                    /*#__PURE__*/ _jsx(Legend, {
                                        verticalAlign: "bottom"
                                    }),
                                    /*#__PURE__*/ _jsx(Line, {
                                        type: "monotone",
                                        dataKey: "revenueA",
                                        name: "partner ใหม่",
                                        stroke: "#ff9700",
                                        strokeWidth: 3,
                                        dot: {
                                            fill: "#ff9700",
                                            r: 5
                                        },
                                        activeDot: {
                                            r: 7
                                        },
                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                            dataKey: "revenueA",
                                            position: "top",
                                            style: {
                                                fontWeight: "bold"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Line, {
                                        type: "monotone",
                                        dataKey: "revenueB",
                                        name: "partner สะสม",
                                        stroke: "#4f7df0",
                                        strokeWidth: 3,
                                        dot: {
                                            fill: "#4f7df0",
                                            r: 5
                                        },
                                        activeDot: {
                                            r: 7
                                        },
                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                            dataKey: "revenueB",
                                            position: "top",
                                            style: {
                                                fontWeight: "bold"
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            tabStatus == 2 && /*#__PURE__*/ _jsx(ReportPartnerDay, {})
        ]
    });
}
